export default __webpack_public_path__ + "static/smart_scheduling_and_resource_management-ccd9a52592e58e114e7f1d6840624e7b.svg";